/**
 * Falls Death Action Types
 *
 * Player dies when performing any action except LOOK at Aragain Falls.
 */

export const FALLS_DEATH_ACTION_ID = 'dungeo.action.falls_death';

export const FallsDeathMessages = {
  DEATH: 'dungeo.falls.death'
} as const;
